export default __webpack_public_path__ + "static/media/livelinklist-browse.5a9c1ce8.png";